import { combineReducers } from 'redux';
import products from './products';
import cart from './cart';
import product from './product';

export default combineReducers({
    products,
    cart,
    product
})
